<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="false" />
    <v-snackbar v-model="showsnackbar" color="primary" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-dialog v-model="appConfirmation" width="500" persistent>
      <v-card>
        <v-card-title class="headline">
          <span style="font-size:16px;font-weight:600">Would you like to delete this Team Member ?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00a972" text @click="appConfirmation = false">Cancel</v-btn>
          <v-btn color="red" text @click="deleteProject">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex xs12 md12 pa-0>
        <v-card id="app_height" outlined tile>
          <v-layout wrap justify-space-around>
            <v-flex xs12 md12 pa-8>
              <v-layout wrap>
                <v-flex xs12 md12 text-center>
                  <span style="font-size:20px;font-weight:500;">Team Members List</span>
                </v-flex>
              </v-layout>
              <v-layout wrap px-2 justify-center>
                <v-flex xs12 sm12 md12>
                  <v-card-title>
                    <v-layout wrap justify-space-around align="center">
                      <v-flex xs12 sm6 md3 pt-3>
                        <router-link tag='span' to="/AddTeamMember">
                          <v-btn text color="primary">Add New Team Member</v-btn>
                        </router-link>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <!-- <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          color="#26af82"
                          label="Search"
                        ></v-text-field> -->
                      </v-flex>
                    </v-layout>
                  </v-card-title>
                  <v-data-table
                    :headers="headers"
                    :items="projects"
                    :items-per-page="itemsPerPage"
                    :search="search"
                    
                    dense
                    :loading="appLoading"
                    loading-text="Loading... Please wait"
                    class="elevation-1"
                    color="#26af82"
                  >
                    <template v-slot:item._id="{ item }">
                      <v-layout>
                        <v-flex>
                          <router-link tag='span' :to="'/ViewTeamMember/'+item._id">
                            <v-btn small text color="green" class="text-capitalize">View</v-btn>
                          </router-link>
                        </v-flex>
                        <v-flex>
                          <router-link tag='span' :to="'/EditTeamMember/'+item._id">
                            <v-btn small text color="blue" class="text-capitalize">Edit</v-btn>
                          </router-link>
                        </v-flex>
                        <v-flex>
                          <v-btn
                            @click="delModel(item)"
                            small
                            text
                            color="red"
                            class="text-capitalize"
                          >Delete</v-btn>
                        </v-flex>
                      </v-layout>
                    </template>
                  </v-data-table>

                 
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import VueElementLoading from "vue-element-loading";
import axios from "axios";
export default {
  components: {
    VueElementLoading
  },
  data() {
    return {
      appLoading: false,
      appConfirmation: false,
      showsnackbar: false,
      timeout: 3000,
      msg: null,
      search: null,
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },

        {
          text: "Role",
          align: "left",
          sortable: false,
          value: "position"
        },
        { text: "Action", align: "center", value: "_id" }
      ],
      projects: [],
      itemsPerPage: 50,
      page: 1,
      totalpages: 0,
      ItemsCount: [5, 10, 25, 50, 500],
      deleteId: null
    };
  },
  beforeMount() {
    this.getTeam();
  },
 
  methods: {
    
    getTeam() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/team/list",
        headers: {
          token: localStorage.getItem("token")
        },
        params: {
          count: this.itemsPerPage,
          page: this.page
        }
      })
        .then(response => {
          this.appLoading = false;
          this.projects = response.data.data;
          for (var i = 0; i < this.projects.length; i++) {
            var dt = new Date(this.projects[i].openDate);
            dt = dt.toString();
            dt = dt.slice(4, 15);
            this.projects[i].openDate = dt;
            dt = new Date(this.projects[i].closeDate);
            dt = dt.toString();
            dt = dt.slice(4, 15);
            this.projects[i].closeDate = dt;
          }
          this.totalpages = response.data.pages;
        })
        .catch(err => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    delModel(event) {
      this.deleteId = event._id;
      this.appConfirmation = true;
    },
    deleteProject() {
      this.appConfirmation = false;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/team/delete/" + this.deleteId,
        headers: {
          token: localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.getTeam();
          this.msg = response.data.msg;
          this.showsnackbar = true;
        })
        .catch(err => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.showsnackbar = true;
        });
    }
  }
};
</script>
<style>
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
    min-width: 80vw;
  }
}
.centered-input input {
  text-align: center;
  height: 20px;
}
</style>